import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'
import { badgeLabel } from '@/lib/menuCounters'

/** F-191 phase 2b: news since the last visit, "99+" above 99. */
export const NewsBadge = ({ count, className }: { count: number; className?: string }) => {
  const { t } = useTranslation('navigation')
  return (
    <span
      className={cn('inline-flex h-5 min-w-[1.25rem] flex-shrink-0 items-center justify-center rounded-full bg-primary px-1.5 text-[11px] font-semibold text-white', className)}
      aria-label={t('sidebar.newItems', { count })}
      data-menu-news={count}
    >
      {badgeLabel(count)}
    </span>
  )
}

/** F-138: the channel's unread mentions, "99+" above 99. */
export const MentionBadge = ({ count, className }: { count: number; className?: string }) => {
  const { t } = useTranslation('common')
  return (
    <span
      className={cn('inline-flex h-5 min-w-[1.25rem] flex-shrink-0 items-center justify-center rounded-full bg-red-600 px-1.5 text-[11px] font-semibold text-white', className)}
      aria-label={t('channelMenu.mentions', { count })}
      data-channel-mentions={count}
    >
      {badgeLabel(count)}
    </span>
  )
}
